import * as React from 'react';

import { cn } from '@/lib/utils';

const TONE_CLASSES = {
	primary: 'bg-primary',
	success: 'bg-success',
	warning: 'bg-warning',
	destructive: 'bg-destructive',
	gradient: 'bg-gradient-unify'
};

/**
 * Linear progress bar used by inventory sync, onboarding steps, and feed
 * quality breakdowns. `value` is a 0-100 percentage; values are clamped.
 */
const ProgressBar = React.forwardRef(({ className, value = 0, tone = 'primary', label, showValue = false, ...props }, ref) => {
	const pct = Math.min(100, Math.max(0, value));
	return (
		<div ref={ref} className={cn('w-full', className)} {...props}>
			{(label || showValue) && (
				<div className="mb-1 flex items-center justify-between text-xs text-muted-foreground">
					{label ? <span>{label}</span> : <span />}
					{showValue ? <span className="font-medium text-foreground tabular-nums">{Math.round(pct)}%</span> : null}
				</div>
			)}
			<div className="h-2 w-full overflow-hidden rounded-full bg-secondary">
				<div
					className={cn('h-full rounded-full transition-[width] duration-500 ease-out', TONE_CLASSES[tone])}
					style={{ width: `${pct}%` }}
				/>
			</div>
		</div>
	);
});
ProgressBar.displayName = 'ProgressBar';

export { ProgressBar };
